// extracted by css-extract-rspack-plugin
export default {"root":"xnRyWZ","inner":"l65RE8","logo":"FhvQx_"};